import { css } from 'styled-components';

import { focusOutline } from './focus-outline.style';

/**
 * The shared "select-style trigger" surface: a full-width button showing a value
 * with the standard border, shadow, radius and focus ring. Consumers add their
 * own padding/size variants and overflow handling on top. Keeps the trigger look
 * + focus ring in one place across CustomFormSelect, CustomFormMultiSelect,
 * FormLinkedItemSearch and FormTagsSearch.
 */
export const selectSurface = css`
  margin: 0;
  width: 100%;

  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  box-shadow: ${({ theme }) => theme.shadowBox.select};
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};

  color: ${({ theme }) => theme.palette.text.primary};
  text-align: left;
  cursor: pointer;

  &:focus {
    ${focusOutline};
  }
`;
